import React from 'react';

const Socials = () => {
  return (
    <div className="socials">
      Override this component to display your social links
    </div>
  );
};

export default Socials;
